import React, {useState, useEffect,Dispatch, startTransition, useContext} from "react";
import { AppContext } from "../../context/AppContext";
import { useNavigate } from "react-router-dom";

interface inputFilterInterface {
    value : string,
    show : boolean,
    id: string,
    listFilter: (string |number | [number,number])[],
    setListFilter: Dispatch<React.SetStateAction<(string |number | [number,number])[]>>,
    resetSearchResto?: () => void,
}

const InputFilter:React.FC<inputFilterInterface> = ({value,show,id,listFilter,setListFilter,resetSearchResto}) => {
    const {setDate_selected,setHour_selected,setValueSearchCity,setSearchCity,setCoordonates} = useContext(AppContext)
    const [isChecked, setIsChecked] = useState(!!(listFilter?.find((elem) => elem === value)));
    const [randomNumber] = useState(Math.floor(Math.random() * 3) + 1);
    const navigate = useNavigate()

    useEffect(() => {
        if (listFilter && listFilter.find((elem) => elem === value) && !isChecked) {
            setIsChecked(true);
        } else if (listFilter && !listFilter.find((elem) => elem === value) && isChecked) {
            setIsChecked(false);
        }
    }, [listFilter]);

    const clickInput = () => {  
        if(isChecked &&  typeof value === 'number' && resetSearchResto) {resetSearchResto()}
        setIsChecked(previousValue => !previousValue)
        const isTimeFilter = value === "Ouvert ce midi" || value === "Ouvert ce soir";
        if(!isChecked) {
            if (isTimeFilter) {
                const other = value === "Ouvert ce midi" ? "Ouvert ce soir" : "Ouvert ce midi";
                const cleaned = listFilter.filter(elem => elem !== other);
                startTransition(() => setListFilter([...cleaned, value]));
                setDate_selected(new Date());
                setHour_selected(value === "Ouvert ce midi" ? "12h30" : "20h00");
            }
            else {
                if(value === 'A proximité') {
                    if(!window.location.pathname.includes('restaurants-a-proximite')){
                        navigate('/restaurants-a-proximite')
                        setValueSearchCity('A proximité')
                    }
                    startTransition(() => setListFilter([...listFilter.filter(prev => typeof prev !== "number"), value]));
                }
                else startTransition(() => setListFilter([...listFilter, value]));
            }
        }else {
            startTransition(() =>
                setListFilter(listFilter.filter(elem => elem !== value))
            );

            if (isTimeFilter) {
                setDate_selected(null);
                setHour_selected("");
            } else if (value === 'A proximité') {
                navigate('/')
                setValueSearchCity('')
                setCoordonates({latitude: "",longitude: ""})
                setSearchCity('')
            }
        }
    }
    const formatValue = (value:string) => {
        if(Array.isArray(value)) return `${value[0]}€ - ${value[1]}€`;   
        else if (typeof value === 'number') return `${value}km`; 
        else return value
    };
    return (
        <>

        {   show &&
            <>
                <input type="checkbox" id={id} onClick={clickInput} checked={isChecked} onChange={()=>{}}/>
                <label   htmlFor={id} className={`XsmallText ${'label'+randomNumber} `} style={{paddingTop:"0.2em"}}> {formatValue(value)}</label>        
            </>
        }
        </>
    )
}

export { InputFilter }